import React, { useState, useEffect } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { filterBy } from "@progress/kendo-data-query";
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import { DateSelectFilterCell } from '../Dashboard/DateSelectFilterCell'
import { ActionDoneFilterCell } from '../Dashboard/ActionDoneFilterCell'
import MoreUpdatesWindow from './MoreUpdatesWindow';
import { Link } from 'react-router-dom';

const options = ['One Hour Ago', '24 Hours Ago', 'One Week Ago', 'One Month Ago']
const actionoptions = ['Update', 'Add', 'Error', 'Deactivate', 'Reactivate']
const currentDate = new Date()

const initialFilter = {
    logic: "and",
    filters: [
        {
            field: "createdDate",
            operator: "gte",
            value: new Date(currentDate.getTime() - 24 * 60 * 60 * 1000)
        },
        {
            field: "actionDone",
            operator: "contains",
            value: ''
        }
    ],
};

const CategoryFilterCell = (props) => (
    <DateSelectFilterCell
        {...props}
        data={options}
        defaultItem={'24 Hours Ago'}
    />
);

const ActionsFilterCell = (props) => (
    <ActionDoneFilterCell
        {...props}
        data={actionoptions}
        defaultItem={''}
    />
);

const initialDataState = {
    skip: 0,
    take: 15,
};

const UserUpdates = () => {
    const [Loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataLength, setDataLength] = useState(0);
    const [jobID, setJobID] = useState(0);
    const [filter, setFilter] = useState(initialFilter);
    const [page, setPage] = useState(initialDataState);
    const [pageSizeValue, setPageSizeValue] = useState();
    const [osuIdmID, setOsuIdmID] = useState('');
    const [showMoreDetails, setShowMoreDetails] = useState(false);

    const pageChange = (event) => {
        const targetEvent = event.nativeEvent ? event.nativeEvent : event.target;
        const take =
            targetEvent.value === "All" ? data.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const fetchData = async () => {
        const result = await api.GetUpdateHistories();
        const data = result.map(data => ({
            ...data,
            jobID: jobID === 0 ? 'Dashboard' : jobID.toString(),
            name: `${data.firstName} ${data.lastName}`,
            ids: `${data.personID} ${data.osuIdmID} ${data.workforceID}`,
            createdDate: new Date(data.createdDate)
        }))
        setData(data);
        setFilter(initialFilter);
        setDataLength(filterBy(data, filter).length)
        setLoading(false)
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setPage({...page, 'skip':0})
        setDataLength(filterBy(data, filter).length)
    }, [filter]);

    const openMoreDetails = (osuIdmID) => {
        setOsuIdmID(osuIdmID)
        setShowMoreDetails(true)
    }

    const closeMoreDetails = () => {
        setShowMoreDetails(false)
    }

    const nameCell = (props) => {
        let url = ''
        if(props.dataItem.workforceID && props.dataItem.workforceID.length && props.dataItem.workforceID != 'null') {
            url=`/Users?workforceid=${props.dataItem.workforceID}`
        } else if(props.dataItem.osuIdmID && props.dataItem.osuIdmID.length && props.dataItem.osuIdmID != 'null') {
            url=`/Users?osuidmid=${props.dataItem.osuIdmID}`
        } else if(props.dataItem.personID && props.dataItem.personID.length && props.dataItem.personID != 'null') {
            url=`/Users?personid=${props.dataItem.personID}`
        }
        return (
          <td {...props.tdProps} >
            {url.length ? <Link to={url}>{props.dataItem.firstName} {props.dataItem.lastName}</Link> : `${props.dataItem.firstName} ${props.dataItem.lastName}`}
          </td>
        );
    };

    const expandButton = (props) => {
        return (
          <td {...props.tdProps} >
            <button aria-label={`more details for ${props.dataItem.osuIdmID}`} onClick={() => openMoreDetails(props.dataItem.osuIdmID)}>+</button>
          </td>
        );
    };

    return (
        <>
            {showMoreDetails && data.length > 0 && <MoreUpdatesWindow osuIdmID={osuIdmID} closeWindow={closeMoreDetails} />}
            <h1 className="page-title">User Updates</h1>
            {Loading
                ? <><Loader className='spinner-small' size="small" type={"infinite-spinner"} /><em> Loading...</em></>
                : <Grid style={{ height: window.innerHeight-200 }}
                    data={filterBy(data, filter).slice(page.skip, page.take + page.skip)}
                    filterable={true} 
                    filter={filter} 
                    onFilterChange={(e) => setFilter(e.filter)}
                    skip={page.skip}
                    take={page.take}
                    total={dataLength}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 15, 25],
                        pageSizeValue: pageSizeValue,
                    }}
                    onPageChange={pageChange}>
                    <GridColumn field="" width='60px' title="" cell={expandButton} filterable={false} />
                    <GridColumn width={200} field="name" title="Name" cell={nameCell} />
                    <GridColumn width={160} field="ids" title="IDs" />
                    <GridColumn width={150} field="actionDone" title="Action" filter={'text'} filterCell={ActionsFilterCell} />
                    <GridColumn field="notes" title="Notes" />
                    <GridColumn width={230} field="createdDate" title="Created Date" filterCell={CategoryFilterCell} format={"{0:G}"} />
                </Grid>
            }
        </>
    );
};

export default UserUpdates;